/** Idiomas da interface: fonte única para o front (i18n, store, Vuetify) e para o backend (link no idioma de quem gerou). */

export const DEFAULT_LOCALE = 'pt-BR';

export const SUPPORTED_LOCALES = ['pt-BR', 'es', 'en', 'pt-PT'];

/** Header em que o front manda o idioma da tela em todo pedido. */
export const LOCALE_HEADER = 'X-App-Locale';

/** Parâmetro do link externo (?lang=es): a página abre no idioma de quem gerou o link. */
export const LOCALE_QUERY_PARAM = 'lang';

/** Só idioma da lista vale: header e link vêm de fora e podem ter sido editados à mão. */
export function isSupportedLocale(value) {
  return SUPPORTED_LOCALES.includes(value);
}

// Países de língua espanhola (ISO 3166-1 alfa-2)
const SPANISH_SPEAKING_COUNTRIES = ['AR', 'BO', 'CL', 'CO', 'CR', 'CU', 'DO', 'EC', 'ES', 'GQ', 'GT', 'HN', 'MX', 'NI', 'PA', 'PE', 'PR', 'PY', 'SV', 'UY', 'VE'];

/**
 * Idioma do cliente pelo país dele (o de nascimento no cadastro): o link externo abre na língua
 * do cliente, não na de quem gerou. Argentino recebia o link em português (04/11/2026). País fora
 * da lista: null, e vale o idioma de quem gerou.
 */
export function localeOfCountry(country) {
  const code = String(country || '').trim().toUpperCase();

  if (code === 'BR') return 'pt-BR';

  if (code === 'PT') return 'pt-PT';

  return SPANISH_SPEAKING_COUNTRIES.includes(code) ? 'es' : null;
}
